import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useDispatch, useSelector } from "react-redux";
import "../../../../StyleSheet/MainComponent/UDSEMployee/Calender.scss";

import { SetCalendarActions } from "../../../../Redux/Slice";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import { useNavigate } from "react-router-dom";

const localizer = momentLocalizer(moment);
const eventStyleGetter = (event) => {
  console.log(event.status, "event");
  let style = {
    backgroundColor:
      event.status === "present"
        ? "rgb(31 220 15 / 48%)"
        // "#1FDC0F"
        : event.status === "weekOff"
          ? "#d8e2fb"
          : event.status === "Working"
            ? "#aac7df"
            : event.status === "Leave" ||
              event.status == "Personal Leave" ||
              event.status == "Casual Leave" ||
              event.status === "Loss Of Pay"
              ? "#234492"
              : "transparent",
    color: "#000",
    width: "100%",
    textAlign: "center",
    height: "3vw",
    display: "flex",
    justifyContent: "center",
    marginTop: "38px",
  };

  return { style };
};
function CalenderUds() {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigate = useNavigate();
  const calendarResponse = useSelector(
    (state) => state.CalendarCall.CalendarData.data
  );
  const [calendarFeeder, setCalendarFeeder] = useState([]);
  const [CountOfRecords, setRecordCounts] = useState({
    PresentCount: 2,
    absentCounts: 0,
  });
  // console.log(CountOfRecords, "PresentCount");
  useEffect(() => {
    const currentDate = new Date();
    const payload = {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
    };
    dispatch(SetCalendarActions(payload));
  }, []);
  useEffect(() => {
    const transformData = (data) => {
      return data.map((item, index) => {
        // console.log(item , "84item", item.leave ? setRecordCounts({...CountOfRecords ,absentCounts:index }): "dsds" );
        console.log(item, "387420830", item.date);
        return {
          id: index,
          title: item.present
            ? "Present"
            : item.weekoff
              ? "Week Off"
              : item.working
                ? "Working"
                : item.leave && item.attendance_type == null
                  ? "Leave"
                  : item.leave &&
                    item.attendance_type != null &&
                    item.attendance_type != undefined &&
                    item.attendance_type.unique_value == "loss_of_pay"
                    ? "Loss Of Pay"
                    : item.leave &&
                      item.attendance_type != null &&
                      item.attendance_type != undefined &&
                      item.attendance_type.unique_value == "personal_leave"
                      ? "Personal Leave"
                      : item.leave &&
                        item.attendance_type != null &&
                        item.attendance_type != undefined &&
                        item.attendance_type.unique_value == "casual_leave"
                        ? "Casual Leave"
                        : "", // default
          start: new Date(item.date),
          end: new Date(item.date),
          status: item.present
            ? "present"
            : item.weekoff
              ? "weekOff"
              : item.leave && item.attendance_type == null
                ? "Leave"
                : item.leave &&
                  item.attendance_type != null &&
                  item.attendance_type != undefined &&
                  item.attendance_type.unique_value == "loss_of_pay"
                  ? "Loss Of Pay"
                  : item.leave &&
                    item.attendance_type != null &&
                    item.attendance_type != undefined &&
                    item.attendance_type.unique_value == "personal_leave"
                    ? "Personal Leave"
                    : item.leave &&
                      item.attendance_type != null &&
                      item.attendance_type != undefined &&
                      item.attendance_type.unique_value == "casual_leave"
                      ? "Casual Leave"
                      : "",
        };
      });
    };

    if (calendarResponse && calendarResponse.length > 0) {
      setCalendarFeeder(transformData(calendarResponse));
    }
  }, [calendarResponse]);
  console.log(calendarResponse, "calendarResponse");
  const handleNavigate = (date, view) => {
    const payload = {
      date: date.getFullYear(),
      month: date.getMonth() + 1,
    };
    dispatch(SetCalendarActions(payload));
  };

  return (
    <div className={stateDisplay ? "outterContent" : "inner-Content"}>
      <div className="row ButtonPrevious Filters"
        style={{
          padding: "4px 4px",
          margin: "0px",
          position: "relative",
          zIndex: "30",
          marginLeft: "0px",
          marginRight: "0px",
          marginTop: "12px",
          marginBottom:"30px"
        }}>
        <div className="col">
          <button
            className="btn BackImga"
            onClick={(e) => {
              navigate("/customattendace");
            }}
          >
            <img className="PreviousPages" src={BackImage} />
            <span></span>

          </button>
        </div>

      </div>
      <div className="calendar-container">
        <div className="leftSection">
          <Calendar
            localizer={localizer}
            events={calendarFeeder}
            startAccessor="start"
            endAccessor="end"
            eventPropGetter={eventStyleGetter}
            views={["month"]}
            onNavigate={handleNavigate}
            style={{ height: '600px' }} /* Adjust the height as needed */

            
          />
        </div>

      </div>
    </div>
  );
}

export default CalenderUds;
